import { render } from "./Questionnaire.html?vue&type=template&id=0cd89368&scoped=true&ts=true"
import script from "./Questionnaire.ts?vue&type=script&lang=ts"
export * from "./Questionnaire.ts?vue&type=script&lang=ts"

import "./Questionnaire.css?vue&type=style&index=0&id=0cd89368&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd89368"]])

export default __exports__